module.exports = __webpack_public_path__ + "img/icbcBg.93dfc461.png";